export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构名称',
        },
        {
            prop: 'bj_num',
            label: '报价个数',
        },
        {
            prop: 'bj_cusFee',
            label: '报价应交服务费(元)',
            sortable: true,
        },
        {
            prop: 'cd_num',
            label: '出单个数',
            sortable: true,
        },
        {
            prop: 'cusFee',
            label: '应交服务费(元)',
            sortable: true,
        },
        {
            prop: 'cashFee',
            label: '现金折扣',
            sortable: true,
        },
        {
            prop: 'netFee',
            label: '净费(元)',
            sortable: true,
        },
        {
            prop: 'realInFee',
            label: '实收金额(元)',
            sortable: true,
        },
    ]
}

export default {}